import { DefaultError, useMutation } from "@tanstack/react-query";
import { useQueryToast } from "hooks";
import i18next from "i18next";
import { apiClient } from "utils";
import { useResponseHandler } from "utils/service/responseHandler";

export const useAddArtistImage = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useAddArtistImage");
  return useMutation<
    {},
    DefaultError,
    { file: File; id: string; isMain: boolean }
  >({
    mutationFn: async (body) => {
      loading(
        i18next.t("service-message.create.loading", {
          what: i18next.t("artist.image-what"),
        })
      );

      const formData = new FormData();

      formData.append("file", body.file);
      formData.append("id", body.id);
      formData.append("isMain", `${body.isMain}`);

      const response = await apiClient<FormData>({
        method: "POST",
        url: `Artist/ImageForm`,
        body: formData,
        withContentType: false,
      });

      return responseHandler(response, {
        groupName: "useAddArtistImage",
      });
    },
    onSuccess: (data) => {
      success(
        i18next.t("service-message.create.success", {
          what: i18next.t("artist.image-what"),
        })
      );
    },
    onError: (error) => {
      dismiss();
    },
  });
};

export const useDeleteArtistImage = (artistId: string) => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useDeleteArtistImage");

  return useMutation<{}, DefaultError, { imageId: string }>({
    mutationFn: async ({ imageId }) => {
      loading(
        i18next.t("service-message.delete.loading", {
          what: i18next.t("artist.image-what"),
        })
      );

      const response = await apiClient({
        method: "DELETE",
        url: `Artist/${artistId}/Image/${imageId}`,
      });

      return responseHandler(response, {
        groupName: "useDeleteArtistImage",
      });
    },
    onSuccess: () => {
      success(
        i18next.t("service-message.delete.success", {
          what: i18next.t("artist.image-what"),
        })
      );
    },
    onError: dismiss,
  });
}; 